import Icona from 'components/3catinfo/ui/Icona';
import Enllac from 'components/3catinfo/Enllac';
import { useViewport } from 'hooks/3catinfo/useViewport';
import styles from './seccionoticieseclipsi.module.scss';

const DestacatEclipsi = (props) => {
    const { item } = props;
    const { routePath, titol, slug, id } = item;
    const route = { slug, type: routePath, id };
    return (
        <Enllac className={styles.enllacCard} route={route}>
            <div className={styles.cardContainer}>
                <div>
                    <p className={styles.titol}>{titol}</p>
                </div>
                <div className={styles.iconaContainer}>
                    <span className={styles.iconaWrapper}>
                        <Icona
                            icona='fletxa_dreta'
                            className={styles.fletxa}
                            alt='fletxa'
                            isBlanc={true}
                            mida={112}
                            inline={true}
                            ariaHidden={true}
                        />
                    </span>
                </div>
            </div>
        </Enllac>
    );
};

const SeccioNoticiesEclipsi = (props) => {
    const { items, imgFons, imgFonsMobile } = props;
    const { isOnlyMobile } = useViewport();
    const imatgeFons = isOnlyMobile && imgFonsMobile ? imgFonsMobile : imgFons;
    return (
        <div className={styles.container} style={{ '--bg-imatge-eclipsi': `url(${imatgeFons})` }}>
            {items && (
                <div className={styles.containerDestacats}>
                    {items.map((item, i) => (
                        <DestacatEclipsi item={item} key={`destacat-eclipsi-${i}`} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SeccioNoticiesEclipsi;
